import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'mtm-chat-sparkle-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './mtm-chat-sparkle-icon.component.html',
  styleUrls: ['./mtm-chat-sparkle-icon.component.scss']
})
export class MtmChatSparkleIconComponent {
  @Input() width: string = '30';
  @Input() height: string = '29';
  @Input() strokeColor: string = 'black';
  @Input() fillColor: string = '#FF6B00';
  @Input() strokeWidth: string = '1.44';
  @Input() class: string = '';
}
